import React from 'react';
import PropTypes from 'prop-types';
import Message from 'components/Message';
import Button from 'components/Button';
import appMessages from 'features/App/App.messages';
import { intlMessage } from 'constants/propTypes';
import FooterBar from './FooterBar';

const SaveBar = ({
  visible,
  submitting,
  desktopNavIsCollapsed,
  submitMessage = appMessages.save,
  formName,
  additionalButtons,
  notice,
  disabled,
}) => (
  <FooterBar visible={visible} desktopNavIsCollapsed={desktopNavIsCollapsed} notice={notice}>
    {!!additionalButtons && additionalButtons}
    <Message
      as={Button}
      form={formName}
      type={Button.TYPES.SUBMIT}
      message={submitMessage}
      waiting={submitting}
      disabled={disabled}
    />
  </FooterBar>
);

SaveBar.propTypes = {
  visible: PropTypes.bool,
  submitting: PropTypes.bool,
  desktopNavIsCollapsed: PropTypes.bool,
  formName: PropTypes.string,
  submitMessage: intlMessage,
  additionalButtons: PropTypes.node,
  notice: PropTypes.node,
  disabled: PropTypes.bool,
};

export default SaveBar;
